{
    "ExcludeheldtimeLabel": "Exclude Held Time:",
    "NAME": "TalkTime",
    "TalkTime_SectionHeader": "Talk Time",
    "TalkTime_SectionPara": "You can choose whether the call talk time related statistics should exclude the held time of the call from the calculation logic."
}